import { type IdentityInfo, FormCache, FormConstants } from '@episerver/forms-sdk';
import { useEffect, useState } from 'react';
import authService from '../../AuthForm/AuthService';

const useFormIdentity = () => {
    const formCache = new FormCache();

    const [identityInfo, setIdentityInfo] = useState<IdentityInfo>({ accessToken: formCache.get<string>(FormConstants.FormAccessToken) } as IdentityInfo);

    useEffect(() => {
        authService.getUser().then(user => {
            if (user?.expired) {
                authService.refreshAccessToken().then(_ => {
                    authService.getUser().then(_user => {
                        // eslint-disable-next-line no-param-reassign
                        user = _user;
                    });
                });
            }
    
            if (user && !user.expired) {
                formCache.set<string>(FormConstants.FormAccessToken, user.access_token);
                setIdentityInfo({ accessToken: user.access_token } as IdentityInfo);
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formCache.get<string>(FormConstants.FormAccessToken)]);

    // console.log('form cache: ', formCache.get<string>(FormConstants.FormAccessToken));

    return identityInfo;
};

export default useFormIdentity;